/**
 * @created on 2017/9/21
 * @author laixinyu <laixinyualex@gmail.com>
 **/

import Vue from 'vue'

import VueRouter from 'vue-router'
import Bridge from 'src/frontend-lib/lib/Bridge'
import { setScrollTop } from 'src/units'
Vue.use(VueRouter)

import consult from './page/consult/index'
import question from './page/question/index'
import lesson from './page/lesson/index'
import fm from './page/fm/index'
import user from './page/user/index'
import qa from './page/qa/index'
import mobilePublic from './page/mobilePublic/index'
import qingsu from './page/qingsu/index'
import personalCenter from './page/personalCenter/index'
import xinlidaily from './page/xinlidaily/index'
import pay from './page/pay/index'
import newsList from './page/newsList/index'

const Index = resolve => require(['../App'], resolve)

const routes = [
  {
    path: '/index',
    component: Index
  },
  ...mobilePublic,
  ...consult,
  ...question,
  ...lesson,
  ...fm,
  ...user,
  ...qa,
  ...qingsu,
  ...personalCenter,
  ...xinlidaily,
  ...pay,
  ...newsList
  // {
  //   path: '/test',
  //   component: resolve =>
  //     require(['src/views/personalCenter/historyRecord'], resolve)
  // }
]

const router = new VueRouter({ routes })
let myBridge = new Bridge({
  methods: [
    // 咨询APP登陆完为刷新页面还是需要使用cookie给后端判断
    {
      method: 'setCookie',
      callback: function(obj) {
        eval(obj.content)
      }
    },
    {
      method: 'getTokenCallback',
      callback: function(options) {
        let token = options.token
        console.log('bridge_token1', token)
      }
    }
  ]
})

// myBridge.call('getCookie', {callbackName: 'setCookie'});

router.beforeEach((to, from, next) => {
  setScrollTop(0)
  let UA = navigator.userAgent
  if (
    UA.indexOf('yixinliApp') >= 0 ||
    UA.indexOf('yixinliConsultationApp') >= 0
  ) {
    myBridge.call('topFuncBtnConfig', {
      btnList: []
    })
    myBridge.call('allowJSControlRefresh', { isAllowed: 0 })
    // getCookie方法已作废

    if (/(?:yixinliConsultationApp)/.test(UA)) {
      myBridge.call('getCookie', { callbackName: 'setCookie' })
    }
    let getToken = myBridge.call('getToken', {
      callbackName: 'getTokenCallback'
    })

    getToken.then(({ token }) => {
      let appToken = token || to.query.token || from.query.token
      if (appToken) {
        localStorage.setItem('token', appToken)
      } else {
        localStorage.removeItem('token')
      }
      // console.log('bridge2_token',token)
      if (!to.query.token && appToken) {
        next({
          path: to.path,
          query: {
            ...to.query,
            token: appToken
          },
          replace: true
        })
      }
    })
  }

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js